import { useOrgIdFromOrgQuery } from './OrgIdFromOrgQuery.generated';

export const useOrgIdFromModel = (name: string): string => {
  // Note: A 404 is expected if the name is not of an org (eg it is a username). This is unavoidable because of route type memberOrOrg's existence. We want to retire the /1/types/[id] endpoint for the purpose of getting an entity's id due to VULN-572232 and the other way to determine if a name belongs to a user or org is to try one and then the other if it 404s
  const { data } = useOrgIdFromOrgQuery({
    variables: { name },
    skip: !name,
  });

  return data?.organization?.id ?? '';
};
